export const PRODUCT_CVE_LIST_SIZE = 50;
